import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import { getUrlParameter, hasUrlParameter, forceInt, dateDisplay } from "../functions";

$(function() {
    $("body").on("click", "#LoadMore", function(e) {
        e.preventDefault();
        var self = this;

        $.ajax({
            type: "GET",
            url: $(self).data("url"),
            dataType: "html",
            success: function(data) {
                $(self)
                    .parents()
                    .first()
                    .append(data);
                $(self).remove();

                $(".equal-height").each(function() {
                    var highestBox = 0;
                    $(".equal", this).each(function() {
                        if ($(this).outerHeight() > highestBox) {
                            highestBox = $(this).outerHeight();
                        }
                    });
                    $(".equal", this).height(highestBox);
                });
            }
        });
    });

    let start = 0,
        limit = 10,
        page = 1;

    if (hasUrlParameter('page')) {
        let pageGetVar = forceInt(getUrlParameter('page'));
        if (pageGetVar > 0) {
            page = pageGetVar;
        }
    }

    $('.load-more-button').on('click', function(e) {
        e.preventDefault();

        const $this = $(this),
            customLimit = forceInt($this.data('limit')),
            resultsParentSelector = $this.data('parent-selector'),
            parent = $this.parents('.load-more-section'),
            pagingStatus = forceInt($this.data('paging-status')),
            paramsExtra = $this.data('params-extra'),
            customUrl = $this.data('custom-url');

        let resultsParentElement = false,
            ajaxLoaderElement = parent.find('.svg-load-more-button-ajax-loader'),
            totalResults = forceInt($this.data('total')),
            start = forceInt($this.data('start')); // 2025-09-19: This needs to be set in the button

        if (!ajaxLoaderElement.length) ajaxLoaderElement = false;

        if (customLimit > 0) {
            limit = customLimit;
        }

        // 2025-09-19: If the data-params-extra is changed, we might need start to be 0 so that the first item display.
        // if (customStart > 0) {
        //     start = customStart;
        // } else {
        //     start += limit;
        // }

        if (resultsParentSelector) {
            resultsParentElement = $(resultsParentSelector);
        }

        $this.hide();
        if (ajaxLoaderElement !== false) ajaxLoaderElement.show();
        // console.log(start, limit);
        console.log({start, limit, totalResults});
        if (resultsParentElement && resultsParentElement.length) {
            let url = window.location.pathname;
            if (customUrl) url = customUrl;
            url += '?start=' + start + '&limit=' + limit + (paramsExtra ? '&' + paramsExtra : ''); // 2025-09-19: Added limit for MemberReviews
            console.log(url);
            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'html',
                success: function(html) {
                    if (html != '') {
                        resultsParentElement.append(html);
                        if (pagingStatus === 1) {
                            const url = new URL(window.location.href);
                            page++;
                            url.searchParams.set('page', page);
                            window.history.replaceState(null, null, url);
                        }
                    }

                    if (ajaxLoaderElement !== false) ajaxLoaderElement.hide();

                    let nextStart = start+limit;
                    if (totalResults > nextStart) {
                        console.log('nextStart', nextStart);
                        $this.data('start', nextStart); // need to set this for pages that have multiple load more sections so that we start from the correct page place for each one
                        $this.show();
                    }

                    dateDisplay();
                }
            });
        }

    });

    const $topFounderBox = $('.top-founder-box');
    if ($topFounderBox.length) {
        const $showMoreButton = $topFounderBox.find('.show-more'),
            $showLessButton = $topFounderBox.find('.show-less');

        if ($showMoreButton.length) {
            $showMoreButton.on('click', function(e) {
                e.preventDefault();
                let contentPreview = $(this).closest('.content-preview');
                let contentFull = contentPreview.next('.content-full');

                contentPreview.hide();
                contentFull.css('display', 'inline');
            });
        }

        if ($showLessButton.length) {
            $showLessButton.on('click', function(e) {
                e.preventDefault();
                let contentFull = $(this).closest('.content-full');
                let contentPreview = contentFull.prev('.content-preview');

                contentFull.hide();
                contentPreview.css('display', 'inline');
            });
        }
    }
});



// WEBPACK FOOTER //
// ./js/modules/load-more.js